import { Box, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import * as setup from 'setup';
import AllInButton from '../AllInButton/AllInButton';
import GameCard from '../GameCard/GameCard';
import GameCardButton from '../GameCardButton/GameCardButton';
import NextHandButton from '../NextHandButton/NextHandButton';
import { Container, FlopLineLeft, FlopLineRight } from './CommunityCards.styled';

export default function CommunityCards({ compact }: CommunityCardsProps) {
    const game = useGame();
    const page = usePage();

    const { hideAllInButton, showRoundCosts: showCardCosts, showCardValues } = game.lessonProps;

    return (
        <Container $overlay={(game.round === 'next' || game.round === 'end') && page.lessonParent === 6}>
            <Typography variant="montserrat514">Community Cards</Typography>
            <Box alignItems="flex-end" display="flex" gap={1} justifyContent="center">
                <Box alignItems="flex-end" display="flex" gap={1} justifyContent="center" position="relative">
                    <FlopLineLeft />
                    <Typography
                        align="center"
                        bottom="100%"
                        left={0}
                        position="absolute"
                        right={0}
                        textTransform="uppercase"
                    >
                        Flop
                    </Typography>
                    <FlopLineRight />
                    <GameCard
                        index={1}
                        name="community-1"
                        side={game.communityCardsSides[0]}
                        type={game.communityCards[0]}
                    />
                    <GameCard
                        index={2}
                        name="community-2"
                        side={game.communityCardsSides[1]}
                        type={game.communityCards[1]}
                    />
                    <GameCard
                        index={3}
                        name="community-3"
                        side={game.communityCardsSides[2]}
                        type={game.communityCards[2]}
                    />
                    <GameCardButton
                        cost={setup.cards.flopCost}
                        round="flop"
                        staticWidth={154}
                        tabIndex={2}
                        type="payFlop"
                    />
                </Box>
                <Box position="relative">
                    {(showCardCosts || showCardValues) && (
                        <Typography bottom={35} left={-4} position="absolute" variant="montserrat714">
                            +
                        </Typography>
                    )}
                </Box>
                <Box position="relative">
                    <Typography align="center" textTransform="uppercase">
                        Turn
                    </Typography>
                    <GameCard name="community-4" side={game.communityCardsSides[3]} type={game.communityCards[3]} />
                    <GameCardButton cost={setup.cards.turnCost} round="turn" tabIndex={3} type="payTurn" />
                </Box>
                <Box position="relative">
                    {(showCardCosts || showCardValues) && (
                        <Typography bottom={35} left={-4} position="absolute" variant="montserrat714">
                            +
                        </Typography>
                    )}
                </Box>
                <Box position="relative">
                    <Typography align="center" textTransform="uppercase">
                        River
                    </Typography>
                    <GameCard name="community-5" side={game.communityCardsSides[4]} type={game.communityCards[4]} />
                    <GameCardButton cost={setup.cards.riverCost} round="river" tabIndex={4} type="payRiver" />
                </Box>
                {showCardValues && setup.cards.valueMultiplier > 1 && (
                    <Typography bottom={35} left="100%" marginLeft={1} position="absolute" variant="montserrat714">
                        &times;{setup.cards.valueMultiplier}
                    </Typography>
                )}
            </Box>

            {!compact && page.lessonParent >= 2 && (
                <Box zIndex={2}>
                    {(game.round !== 'next' || page.lessonParent !== 6) && !hideAllInButton && <AllInButton />}
                    {game.round === 'next' && page.lessonParent === 6 && <NextHandButton />}
                </Box>
            )}
        </Container>
    );
}
